import {mapActions, mapGetters} from "vuex";

export default {
    mounted() {
        this.fetchCurrencies()
            .finally(() => {
                this.baseCurrencyShortName = this.getUserCompany.baseCurrency ? this.getUserCompany.baseCurrency.shortName : "UZS"
                this.currentCurrencyShortName = this.baseCurrencyShortName
                this.currency = this.getCurrencies.filter((c) => c.shortName !== this.baseCurrencyShortName)
                this.baseCurrencyId = this.getCurrencyByShortName(this.baseCurrencyShortName).id
            })
    },
    data() {
        return {
            baseCurrencyShortName: "UZS",
            baseCurrencyId: 0,
            currentCurrencyShortName: "UZS",
            currency: []
        }
    },
    computed: mapGetters(['getProduct','getUserCompany','getCurrencies', 'getCurrencyByShortName', 'getIsNeedFetch']),
    methods: {
        ...mapActions(['fetchCurrencies', 'setIsNeedFetch']),
        // product
        showCurrencyByProductId(id) {
            return this.showCurrencyByProduct(this.getProduct(id))
        },
        showCurrencyByProduct(product) {
            return this.showCurrencyById(product.sellingPriceCurrency.id, product.sellingPrice)
        },
        showUnitOfMeasure(unit) {
            if (unit === undefined) {
                return ''
            }

            if (Object.prototype.hasOwnProperty.call(this.$i18n.messages.en.unitOfMeasure, unit)) {
                return this.$t('unitOfMeasure.' + unit)
            }

            return unit
        },

        // product.divided
        showCurrencySymbolByProductId(id) {
            return this.showCurrencySymbolByProduct(this.getProduct(id))
        },
        showCurrencySymbolByProduct(product) {
            return this.showCurrencySymbolById(product.sellingPriceCurrency.id)
        },

        //main
        showCurrencyById(id, amount) {
            let currency = this.$store.getters.getCurrency(id)

            if (!currency) {
                if (typeof amount !== 'number') {
                    amount = parseFloat(amount)
                }

                return amount.toFixed(2)
            }

            return this.showCurrency(currency, amount)
        },
        showCurrency(currency, amount) {
            let str = '' + this.showCurrencyAmount(amount, currency.hasPennies)
            return str.split("").reverse().join("").replace(/(\d{3})/g, '$1 ').replace(/(^\s+|\s+$)/, '').split("").reverse().join("") + ' ' + this.showCurrencySymbol(currency)
        },
        showCurrencyByIdWithoutSymbol(id, amount) {
            let currency = this.$store.getters.getCurrency(id)

            if (!currency) {
                if (typeof amount !== 'number') {
                    amount = parseFloat(amount)
                }

                return parseFloat(amount.toFixed(2))
            }

            return this.showCurrencyWithoutSymbol(currency, amount)
        },
        showCurrencyWithoutSymbol(currency, amount) {
            let str = '' + this.showCurrencyAmount(amount, currency.hasPennies)
            return str.split("").reverse().join("").replace(/(\d{3})/g, '$1 ').replace(/(^\s+|\s+$)/, '').split("").reverse().join("")
        },


        // main, divided
        showCurrencySymbolById(id) {
            return this.showCurrencySymbol(this.$store.getters.getCurrency(id))
        },
        showCurrencySymbol(currency) {
            if (currency === undefined) {
                return ''
            }

            if (currency.symbol === 'U') {
                return currency.shortName
            }

            return currency.shortName
        },
        showCurrencyAmountById(id, amount) {
            return this.showCurrencyAmount(amount, this.$store.getters.getCurrency(id).hasPennies)
        },
        showCurrencyAmount(amount, hasPennies) {
            if (typeof amount === 'string') {
                amount = parseFloat(amount)
            }

            if (hasPennies) {
                return parseFloat(amount.toFixed(2))
            }

            return Math.round(amount)
        },
    },
}
